/**
 * AssertionBadge.js
 * Created by calhosh on 11/6/2019.
 */
import React from 'react';
import {SVGICONS} from '@ey/icons';
import styled from 'styled-components';
import CRABadges from '../CRABadges/CRABadges';
import EllipseControl from '../EllipsesControl/EllipsesControl';
import Checkbox from '../BaseComponentWrappers/MotifCheckbox';
import {labels} from '../../../util/utils';
import Icon from '../BaseComponentWrappers/MotifIcon';
import {IconoirMinus, IconoirPlus} from '@ey-xd/motif-icon';

export default function AssertionBadge(props) {
	const {
		assertion,
		showName,
		displayName,
		showCheckbox,
		checked,
		checkboxDisabled,
		showExpandCollapse,
		hasEstimate,
		onCheckboxChange,
		noBackground,
		showAddedLabel,
		showLabelInline,
		showAbbreviationTooltipOnly,
		noBackgroundYesTooltip,
		inherentRiskView
	} = props;

	const onChangeHandler = (e) => {
		onCheckboxChange(e);
	};

	return (
		<StyledAssertionBadge
			className="AssertionBadge"
			id={assertion.knowledgeAssertionId}
			onClick={() => {
				if (props.onClick) {
					props.onClick(assertion);
				}
			}}
		>
			{showExpandCollapse && (
				<span className="plusminusIcons" title={isExpanded ? labels.collapse : labels.expand}>
					<Icon
						className={`medium`}
						src={isExpanded ? IconoirMinus : IconoirPlus}
						title={isExpanded ? labels.collapse : labels.expand}
					/>
				</span>
			)}
			{showCheckbox && showCheckbox === true && (
				<Checkbox
					id={assertion.id}
					name="assertionCheckBox"
					onChange={onChangeHandler}
					disabled={checkboxDisabled}
					checked={checked}
					value={assertion.id}
				/>
			)}
			<CRABadges
				assertionsId={assertion.knowledgeAssertionId}
				craValue={assertion.craValue}
				inherentRiskTypeId={assertion.inherentRiskTypeId}
				controlRiskTypeId={assertion.controlRiskTypeId}
				hasRiskAssociated={assertion.hasRiskAssociated}
				notForDisplay={assertion.notForDisplay}
				noBackground={noBackground}
				noBackgroundYesTooltip={noBackgroundYesTooltip}
				assertionName={assertion.assertionname}
				assertionAbbreviation={assertion.assertionabbreviation}
				showAbbreviationTooltipOnly={showAbbreviationTooltipOnly}
				inherentRiskView={inherentRiskView}
			/>
			{showName && displayName && displayName.length > 0 && (
				<>
					<section className="link-item">
						<EllipseControl
							id={assertion.knowledgeAssertionId}
							content={displayName}
							tooltip={displayName}
							noOfLines={1}
						/>
					</section>
					{hasEstimate && (
						<section className="has-estimate" title={labels.estimate}>
							<SVGICONS styleName="medium" name="estimate" hoverText={labels.estimate} />
						</section>
					)}
				</>
			)}
			{showName && (!displayName || displayName.length === 0) && (
				<>
					<section className={`${showLabelInline ? 'inline-label' : 'link-item'}`}>
						<EllipseControl
							id={assertion.knowledgeAssertionId}
							content={assertion.assertionname}
							tooltip={assertion.assertionname}
							noOfLines={1}
						/>
					</section>
					{hasEstimate && (
						<section className="has-estimate" title={labels.estimate}>
							<SVGICONS styleName="medium" name="estimate" hoverText={labels.estimate} />
						</section>
					)}
				</>
			)}
			{showAddedLabel && checked && <span className="addedLabel">{labels.added}</span>}
		</StyledAssertionBadge>
	);
}

const StyledAssertionBadge = styled.section`
	.has-estimate {
		padding: var(--px-3) var(--px-5);
		color: var(--neutrals-700);
		font-size: var(--px-12);
		line-height: normal;
		margin-right: var(--px-10);
		font-weight: normal;
		fill: var(--neutrals-700);
	}
	.inline-label {
		display: inline-block;
		font-size: var(--px-32);
		font-weight: 600;
	}
`;
